<section class="cdfi-page">
  @if (isAnonymous) {
    <div class="cta-container public-cta">
      <div class="cta-content">
        <span class="cta-badge">Organization marketplace</span>
        <h2 class="cta-title">Explore Mission-Driven Lenders</h2>
        <p class="cta-description">
          Browse Community Development Financial Institutions and review their
          contact details, lending focus, products, and service areas.
        </p>
      </div>
    </div>
  }
  @if (isSmeUser) {
    <div class="cta-container">
      <div class="cta-content">
        <span class="cta-badge">Organization marketplace</span>
        <h2 class="cta-title">Find Mission-Driven Lenders</h2>
        <p class="cta-description">
          Connect with Community Development Financial Institutions that support
          small businesses. Review their profiles and prepare your business
          profile for lending conversations.
        </p>
      </div>
      <div class="cta-action">
        <button
          type="button"
          class="action-btn"
          (click)="navigateToBusinessRecords()"
        >
          Prepare My Business Profile
        </button>
      </div>
    </div>

    <div class="metrics-grid">
      <div
        class="metric-card"
        id="tour-org-profile-views"
        [class.has-open-tooltip]="activeTooltip === 'profile-views'"
      >
        <svg
          class="metric-icon views-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">{{ profileViewsCount }}</span>
          <span class="metric-label">PROFILE VIEWS</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('profile-views', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "profile-views") {
            <div class="info-tooltip">
              <span class="tooltip-title">Profile Views</span>
              <p>
                The number of times organizations and their team members have
                viewed your personal profile.
              </p>
            </div>
          }
        </div>
      </div>

      <div
        class="metric-card"
        id="tour-assigned-partners"
        [class.has-open-tooltip]="activeTooltip === 'assigned-partners'"
      >
        <svg
          class="metric-icon cdfi-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">{{ assignedRecordsCount }}</span>
          <span class="metric-label">ASSIGNED PARTNERS</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('assigned-partners', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "assigned-partners") {
            <div class="info-tooltip">
              <span class="tooltip-title">Assigned Partners</span>
              <p>
                The number of Organizations (CDFIs, lenders, or support
                organizations) that have been assigned to your business profile.
              </p>
            </div>
          }
        </div>
      </div>

      <div
        class="metric-card"
        id="tour-total-funded"
        [class.has-open-tooltip]="activeTooltip === 'total-funded'"
      >
        <svg
          class="metric-icon funding-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.77 7.58 16.73 7.32 14.97H9.14C9.32 16.02 10.07 16.69 11.97 16.69C14.05 16.69 14.54 15.72 14.54 15.03C14.54 14.14 14.04 13.38 11.5 12.82C8.63 12.18 7.08 11.13 7.08 9.01C7.08 7.35 8.36 6.13 10.74 5.76V4H13.41V5.78C15.54 6.23 16.38 7.68 16.5 9.16H14.67C14.57 8.12 14.03 7.3 11.97 7.3C10.12 7.3 9.42 8.08 9.42 8.95C9.42 9.75 10.03 10.32 12.36 10.84C14.69 11.36 16.88 12.19 16.88 15.06C16.87 16.8 15.59 17.93 13.41 18.09Z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">
            @if (fundedAmount) {
              {{ fundedAmount | currency: "USD" : "symbol" : "1.0-0" }}
            } @else {
              $0
            }
          </span>
          <span class="metric-label">TOTAL FUNDED</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('total-funded', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "total-funded") {
            <div class="info-tooltip">
              <span class="tooltip-title">Total Funded</span>
              <p>
                The cumulative dollar amount of funding that has been committed
                or disbursed to your business through partnerships formed on
                this platform.
              </p>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <div class="cdfi-section">
    <div class="cdfi-header">
      <h3>Organizations</h3>
      <div class="cdfi-header-actions">
        @if (!isSmeUser && isAdmin) {
          <div class="export-dropdown-container">
            <button
              type="button"
              class="export-btn"
              [class.open]="isExportMenuOpen"
              [disabled]="isExporting"
              (click)="toggleExportMenu($event)"
              aria-label="Export CDFI data"
              aria-haspopup="true"
              [attr.aria-expanded]="isExportMenuOpen"
            >
              @if (isExporting) {
                <svg
                  class="spinner-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                    opacity="0.25"
                  ></circle>
                  <path
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span class="export-txt">Exporting...</span>
              } @else {
                <svg
                  class="export-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span class="export-txt">Export</span>
                <svg
                  class="chevron-icon"
                  [class.rotated]="isExportMenuOpen"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              }
            </button>

            @if (isExportMenuOpen) {
              <div
                class="export-menu"
                role="menu"
                tabindex="-1"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              >
                <div class="export-menu-header">Export Format</div>
                <button
                  type="button"
                  class="export-menu-item"
                  (click)="exportData('csv')"
                >
                  <div class="format-icon-badge csv-badge">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                      />
                      <polyline points="14 2 14 8 20 8" />
                      <path d="M8 13h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H8v5" />
                    </svg>
                  </div>
                  <div class="format-details">
                    <span class="format-name">CSV File (.csv)</span>
                    <span class="format-desc"
                      >Spreadsheet compatible format</span
                    >
                  </div>
                </button>
                <button
                  type="button"
                  class="export-menu-item"
                  (click)="exportData('json')"
                >
                  <div class="format-icon-badge json-badge">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                      />
                      <polyline points="14 2 14 8 20 8" />
                      <path
                        d="M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1"
                      />
                      <path
                        d="M14 12a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1 1 1 0 0 0-1 1v1a1 1 0 0 1-1 1"
                      />
                    </svg>
                  </div>
                  <div class="format-details">
                    <span class="format-name">JSON File (.json)</span>
                    <span class="format-desc"
                      >Structured data interchange format</span
                    >
                  </div>
                </button>
              </div>
            }
          </div>
        }

        <div class="cdfi-count">
          {{ totalItems }} {{ totalItems === 1 ? "Partner" : "Partners" }}
        </div>
      </div>
    </div>

    <div class="search-section">
      <div class="search-wrapper">
        <app-search-input
          id="tour-organization-search"
          [placeholder]="'Search by lender name...'"
          [(searchQuery)]="searchQuery"
          (searchQueryChange)="onSearchQueryChange($event)"
        ></app-search-input>
        @if (cdfiProfiles.length > 0) {
          <div class="page-size">
            <app-page-size
              [pageSize]="pageSize"
              [selectId]="'cdfi-marketplace'"
              (pageSizeChanged)="onPageSizeChange($event)"
            ></app-page-size>
          </div>
        }
      </div>
    </div>

    @if (loading) {
      <app-skeleton [type]="'cdfi-list'"></app-skeleton>
    } @else {
      <div class="list-wrapper">
        @for (profile of cdfiProfiles; track profile.id; let i = $index) {
          <article
            class="cdfi-card"
            (click)="onCdfiProfile(profile)"
            tabindex="0"
            (keydown.enter)="onCdfiProfile(profile)"
            [id]="'tour-organization-item-' + i"
          >
            <div class="avatar-container">
              @if (profile.cdfi_logo) {
                <img
                  [src]="getImageUrl(profile.cdfi_logo)"
                  alt="CDFI logo"
                  class="avatar-img"
                />
              } @else {
                <div class="avatar-initials">
                  {{ profile.name.charAt(0).toUpperCase() }}
                </div>
              }
            </div>

            <div class="card-main">
              <div class="card-title-row">
                <h2>{{ profile.name }}</h2>
              </div>
              <p [class.placeholder-text]="!profile.description">
                {{ getDescriptionPreview(profile.description) }}
              </p>
              <div class="marketplace-tags">
                @for (tag of getMarketplaceTags(profile); track tag.type) {
                  <div
                    class="contact-item"
                    [class.empty]="tag.isEmpty"
                    [title]="tag.tooltip"
                  >
                    @if (tag.icon === "email") {
                      <svg
                        class="contact-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                          fill="currentColor"
                        />
                      </svg>
                    } @else if (tag.icon === "phone") {
                      <svg
                        class="contact-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
                          fill="currentColor"
                        />
                      </svg>
                    } @else if (tag.icon === "website") {
                      <svg
                        class="contact-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z"
                          fill="currentColor"
                        />
                      </svg>
                    }
                    <span>{{ tag.label }}</span>
                  </div>
                }
              </div>
            </div>

            <a href="javascript:void(0)" class="right-arrow"> </a>
          </article>
        } @empty {
          <div class="empty-state">
            <app-svg-icon
              [iconName]="'cdfis-list.svg'"
              [width]="'42px'"
              [height]="'42px'"
            ></app-svg-icon>
            <strong>No Organizations found</strong>
            <span
              >Try a different search or check back as new partners are
              added.</span
            >
          </div>
        }
      </div>

      @if (cdfiProfiles.length > 0) {
        <div class="pagination-wrapper">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageSize"
            [totalItems]="totalItems"
            (pageChanged)="onPageChange($event)"
          ></app-pagination>
        </div>
      }
    }
  </div>
</section>
